import React from "react";
import Layout from "../components/layout/layout.jsx";
import { graphql, Link } from "gatsby";
import "./designPages.scss";
import Random from  "another-random-package";
import makeConfig from "../modules/makeConfig";
import { BLOCKS } from "@contentful/rich-text-types"
import RichText from "@madebyconnor/rich-text-to-jsx";
import {GatsbyImage, getImage} from "gatsby-plugin-image";




export const query = graphql`
  query pages($slug: String) {
    allContentfulDesign(filter: { slug: { eq: $slug } }) {
      nodes {
        imageOrder
        credits {
          raw
        }
        description {
          description
          childMarkdownRemark {
            html
          }
        }
        hugePhotos {
          file {
            url
          }
         gatsbyImageData(formats: [AUTO, WEBP])
        }
        name
        slug
        tallPhotos {
          file {
            url
          }
         gatsbyImageData(formats: [AUTO, WEBP])
        }
      }
    }
  }
`;

const Name = ({contents}) => {
    if(contents instanceof String){
        return (<cite>{contents}</cite>)
    }else if(contents){
            let {props, props: {children}} = contents;
            let type = contents?.type || "span";
            return (
                <span
                className={"credits-link"}>
                {React.createElement(type, {...props, ...{target: "_blank"}}, children)}
                </span>);

    }else{
        return ""
    }
}
//todo check if credit is blank to avoid that error in the future
// rewrite credits section to be more robnust
// fix topper to be overflow hidden

// with link == [title,ReactElement,""]
// w/o  link == ["title : name"]


const Credits = ({children}) => {
    let [childOne,childTwo] = children[0].split(":");
    let contents = childTwo === "" ? childTwo : children[1];
    if(typeof childTwo === "string" && children[1] === undefined ){
        return (
            <div className={"credit-wrapper"}>
            <span
                className={"primary"}>
                {childOne}
            </span> : {" "}
                <span>{childTwo}</span>
            </div>
        )
    }
    return(
        <div className={"credit-wrapper"}>
            <span
                className={"primary"}>
                {childOne}
            </span> : {" "}
            <Name contents={contents} />
        </div>
    )
}

function DesignPages(query) {
    const { name, description, photos, credits } = makeConfig(query);
    return (
        <Layout current={"design"} name={name}  layout={"design-page"}>
            <section className="design-container">
                <aside>
                    <h1 className="orange desktop">{name}</h1>
                    <br />
                    <div dangerouslySetInnerHTML={{
                        __html: description,
                    }}/>
                    <br />
                    <br />
                    {credits !== "" && <RichText
                        richText={JSON.parse(credits)}
                        overrides={{
                            [BLOCKS.PARAGRAPH]:Credits
                        }}
                    />}
                    <br/>
                    <Link to={"/design"} className={"back-button"}> Back </Link>
                </aside>
                <div className="image-container">
                    {photos &&
                    photos.map(photo => {
                        return (
                        <span className={photo.size} key={Random.randomStringAlphaNumeric(12)}>
                        <GatsbyImage alt={""} image={getImage(photo)}/>
                        </span>
                    )}
                    )}
                </div>
                <h1 className="orange mobile">{name}</h1>
            </section>
        </Layout>
    );
}

export default DesignPages;
